import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorHeading: {
		id: 'spa-apps-sidebar-common.common.error-boundary.fallback.error-heading',
		defaultMessage: 'Something went wrong',
		description: 'telling users that an error has occurred',
	},
	errorBody: {
		id: 'spa-apps-sidebar-common.common.error-boundary.fallback.error-body',
		defaultMessage: 'Try refreshing or navigating to another page.',
		description: 'Suggest an action to the user',
	},
});
